import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-turns-reports-apppicked-card',
  templateUrl: './turns-reports-apppicked-card.component.html',
  styleUrls: ['./turns-reports-apppicked-card.component.scss']
})
export class TurnsReportsApppickedCardComponent implements OnInit {

  @Input() value;

  constructor() { }

  ngOnInit() {
  }

}
